var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqlServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 10.04,
    x2: 13.18,
    y2: 10.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0074cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#006abb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84 5.09c-3.5 0-6.34-1-6.34-2.3V15c0 1.26 2.79 2.28 6.25 2.3h.09c3.5 0 6.34-1 6.34-2.3V2.79c0 1.27-2.84 2.3-6.34 2.3z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.18 2.79c0 1.27-2.84 2.3-6.34 2.3S.5 4.06.5 2.79 3.34.49 6.84.49s6.34 1 6.34 2.3",
    fill: "#e8e8e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 2.6c0 .81-2.18 1.46-4.86 1.46S2 3.41 2 2.6s2.16-1.46 4.84-1.46 4.86.66 4.86 1.46",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84 2.94A12 12 0 003 3.49a11.25 11.25 0 003.85.57 11.25 11.25 0 003.85-.57 12 12 0 00-3.86-.55z",
    fill: "#198ab3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.74 11.1V7.72h-.93v4.14h2.46v-.76zM3.59 9.43a1.92 1.92 0 01-.51-.31A.44.44 0 013 8.8a.38.38 0 01.16-.31.72.72 0 01.42-.11 1.67 1.67 0 011 .29v-.86a2.67 2.67 0 00-1-.16 1.74 1.74 0 00-1.2.35 1.13 1.13 0 00-.41.9c0 .51.32.91 1 1.21a2.9 2.9 0 01.61.36.4.4 0 01.16.32.38.38 0 01-.16.31.75.75 0 01-.45.12A1.6 1.6 0 012 10.77v.93a2.29 2.29 0 001.07.23 2 2 0 001.18-.32 1.1 1.1 0 00.43-.92 1 1 0 00-.25-.7 2.42 2.42 0 00-.84-.56zM8.79 11a2.4 2.4 0 00.33-1.27 2.32 2.32 0 00-.25-1.1 1.81 1.81 0 00-.7-.75 2 2 0 00-1-.26 2.18 2.18 0 00-1.09.27 1.87 1.87 0 00-.73.77 2.41 2.41 0 00-.26 1.15 2.26 2.26 0 00.24 1.05 1.83 1.83 0 00.68.75 2 2 0 001 .29l.85 1h1.19l-1.2-1.11a1.81 1.81 0 00.94-.79zm-.93-.26a1 1 0 01-1.53 0 1.51 1.51 0 01-.28-1 1.48 1.48 0 01.29-1 .92.92 0 01.78-.37.89.89 0 01.75.37 1.62 1.62 0 01.27 1 1.46 1.46 0 01-.28 1.03z",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 17.49l.24-.79.47-.27.81.36.52-.53v-.06l-.37-.71.22-.5.81-.29h.09v-.73h-.1l-.8-.24-.26-.46.35-.82-.53-.51h-.06l-.71.36L15 12l-.32-.89h-.74v.11l-.24.79-.51.22-.87-.4-.51.53.05.1.38.74-.2.51-.94.29v.74h.11l.79.24.22.51-.39.86.53.52.09-.05.74-.38.51.2.34.89h.73zm-1.2-2.36a1.06 1.06 0 111.49-1.52 1.06 1.06 0 01-1.49 1.52z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlServer);
export default __webpack_public_path__ + "static/media/SQL-Server.b28b5d01b09f4e1e53636b687d246af5.svg";
export { ForwardRef as ReactComponent };